import { Theme } from '@mui/material/styles';
import { tss } from 'tss-react';

export const useStyles = tss
  .withParams<{ theme: Theme; isMp: boolean }>()
  .create(({ theme, isMp }) => ({
    input: {
      width: '100%',
      height: '51px',
      '& .MuiInputBase-root': {
        height: '100% !important',
        backgroundColor: 'white',
        ...(isMp && { boxShadow: theme.customShadows.main }),
        [theme.breakpoints.down('md')]: {
          borderBottomRightRadius: 0,
          borderBottomLeftRadius: 0,
          border: '1px solid #E6E6E6',
        },
        [theme.breakpoints.up('md')]: {
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
        },
      },

      '& input': {
        fontSize: '18px',
      },
      '& fieldset': {
        border: 'none',
      },
    },
    iconButton: {
      padding: '6px',
      marginRight: '2px',
      position: 'absolute',
      top: '50%',
      right: 0,
      display: 'flex',
      transform: 'translateY(-50%)',
    },
    filterButton: {
      borderRadius: '0px',
      height: '51px',
      width: '100%',
      backgroundColor: 'white !important',
      color: theme.palette.grey['500'],
      maxWidth: '180px',
      minWidth: '180px',
      ...(isMp && { boxShadow: theme.customShadows.main }),
      [theme.breakpoints.down('md')]: {
        maxWidth: '100%',
        justifyContent: 'flex-start',
        minWidth: '100%',
        border: '1px solid #E6E6E6',
        borderTop: 'none',
      },
      [theme.breakpoints.up('md')]: {
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0,
      },
    },
    filterCount: {
      color: 'white',
      marginLeft: '10px',
      '& .MuiBadge-badge': {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: theme.palette.primary.main,
        fontSize: theme.typography.body1.fontSize,
        borderRadius: '50%',
        fontWeight: 500,
        height: 24,
        width: 24,
      },
    },
    searchButton: {
      borderRadius: '0 4px 4px 0',
      height: '51px',
      width: '100%',
      maxWidth: '110px',
      minWidth: '110px',
      [theme.breakpoints.down('md')]: {
        maxWidth: '100%',
        minWidth: '100%',
        borderRadius: '0 0 4px 4px',
      },
    },

    chips: {
      backgroundColor: 'white',
      fontSize: theme.typography.body1.fontSize,
    },
    deleteIcon: {
      color: 'grey.500',
      padding: 0,
    },
  }));
